import {Component, EventEmitter, inject, input, Output, signal} from '@angular/core';
import {VismaOrderDetailV2} from '../../core/interfaces/generated/graphql';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable
} from '@angular/material/table';
import {MatPaginator, MatPaginatorIntl, PageEvent} from '@angular/material/paginator';
import {PricePipe} from '../../core/pipes/price.pipe';
import {OrderHistoryService} from '../../core/services/order-history.service';
import {CustomPaginatorIntl} from '../../core/custom-material/mat-paginator';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {OrderLineItemTableComponent} from '../order-line-item-table/order-line-item-table.component';
import {DragScrollDirective} from '../../core/directives/drag-scroll.directive';

@Component({
  selector: 'app-order-table',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatCellDef,
    MatHeaderCellDef,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    DatePipe,
    PricePipe,
    CurrencyPipe,
    MatPaginator,
    OrderLineItemTableComponent,
    DragScrollDirective,
  ],
  providers: [{provide: MatPaginatorIntl, useClass: CustomPaginatorIntl}],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  templateUrl: './order-table.component.html',
  styleUrl: './order-table.component.scss'
})
export class OrderTableComponent {

  orderHistoryService = inject(OrderHistoryService);

  displayedColumns = input<string[]>(['date', 'orderNumber', 'storeName', 'status', 'totalPrice']);
  orders = input<VismaOrderDetailV2[]|undefined>([]);
  totalItems = input<number>(0);
  pageIndex = input<number>(0);
  expandedElement = signal<VismaOrderDetailV2|undefined>(undefined);

  @Output() pageChange = new EventEmitter<number>();

  getHumanStoreName(storeName?: string) {
    if (!storeName) {
      return 'Ukendt';
    }
    return this.orderHistoryService.getHumanStoreName(storeName);
  }

  getHumanStatus(status?: string) {
    if (!status) {
      return 'Ukendt';
    }
    return this.orderHistoryService.getHumanStatus(status);
  }

  changePage(pageEvent: PageEvent) {
    this.pageChange.emit(pageEvent.pageIndex);
  }
}
